module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center big-padding"
  }, [_vm._v("\n    Souhaitez-vous supprimer le secteur "), _c('strong', [_vm._v(_vm._s(_vm.secteur.nom))]), _vm._v(" (" + _vm._s(_vm._f("arrondissementName")(_vm.secteur.arrondissement_id)) + ") ?\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("\n      Supprimer\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Annuler\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c6d28aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/secteurs/SecteursDelete.vue
// module id = 2120
// module chunks = 2